import { render, staticRenderFns } from "./CourseCardSummary.vue?vue&type=template&id=e57ed6da&scoped=true&"
import script from "./CourseCardSummary.vue?vue&type=script&lang=js&"
export * from "./CourseCardSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57ed6da",
  null
  
)

export default component.exports